import { DocumentModel } from '../ts/interfaces/models/DocumentModel';
import { BaseService } from './baseService';

class DocumentService extends BaseService<DocumentModel> {
  controllerName = 'documents';
}

export const documentService = new DocumentService();
